import { useLocation } from 'react-router-dom';
import { useEffectOnce } from '@core/js/hooks/useEffectOnce';
import { setAffiliateCookie } from '@core/js/utils/affiliate.util';

// @theme
import { isEmpty } from 'ramda';

export const useAffiliate = () => {
    const location = useLocation();

    useEffectOnce(() => {
        const params = Object.fromEntries(new URLSearchParams(location.search));

        // #region @theme
        if (!isEmpty(params)) {
            setAffiliateCookie(params);
        }
        // #endregion
    }, [location]);
};
